webpackJsonp([119574102423184],{

/***/ 2046:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"TeletailsSession","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"result","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-teletails-session-e75e6299d4450a903dd3.js